// @flow
import * as React from 'react';

import BoxBody from 'components/BoxBody';
import Button from 'components/ButtonDeprecated';
import Dialog from 'components/Dialog';
import EventTracking from 'lib/EventTracking';
import FreeClassLimitsLearnMoreDialog from 'groups/components/FreeClassLimitsLearnMoreDialog';
import Image from 'components/Image';
import Link from 'components/Link';
import LinkConstants from 'constants/LinkConstants';
import List from 'components/List';
import ListItem from 'components/ListItem';
import MediaObject from 'components/MediaObject';
import ModalTrigger from 'components/ModalTrigger';
import Row from 'components/Row';
import ScrollableArea from 'components/ScrollableArea';
import Text from 'components/Text';

import LimitedFreeClassAvatar from 'assets/images/avatars/limited-free-class-avatar.svg';

type Props = {
  limitedClassNames: $ReadOnlyArray<string>,
  onRequestHide: () => void,
};

export const eventKeyPrefix = 'free_product_limits.limited_classes_modal';

export default class LimitedClassesModal extends React.PureComponent<Props> {
  componentDidMount() {
    this.trackEvent('view');
  }

  trackEvent(event: string) {
    EventTracking.trackKey(`${eventKeyPrefix}.${event}`);
  }

  render() {
    return (
      <Dialog
        size="xxsmall"
        title="Announcements aren’t available for some of your classes"
        onRequestHide={this.props.onRequestHide}>
        <BoxBody>
          <Row>
            <ScrollableArea maxHeight={150}>
              <Text align="left">
                <List size="large">
                  {this.props.limitedClassNames.map(name => (
                    <ListItem>
                      <MediaObject gutter="small" center>
                        <Image src={LimitedFreeClassAvatar} />
                        {name}
                      </MediaObject>
                    </ListItem>
                  ))}
                </List>
              </Text>
            </ScrollableArea>
          </Row>
          <Text size="small" color="graphite">
            <Row size="small">
              <Text weight="semibold">
                These classes exceed your account limit of 10 classes with 150 participants each.
              </Text>
            </Row>
            <Row size="small">
              <Text>
                If your organization has purchased Remind Hub, make sure these classes are{' '}
                <Link href={LinkConstants.LINK_CLASS_TO_SCHOOL} target="_blank">
                  linked to the correct organization
                </Link>{' '}
                to enable announcements.
              </Text>
            </Row>
          </Text>
          <ModalTrigger
            onClick={() => {
              this.trackEvent('learn_more.click');
              this.props.onRequestHide();
            }}
            modal={
              <FreeClassLimitsLearnMoreDialog
                onRequestHide={() => { }}
                uiContext="limited_classes_modal"
              />
            }>
            <Button full>Learn more</Button>
          </ModalTrigger>
        </BoxBody>
      </Dialog>
    );
  }
}
